import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

var Restriccion = Object.create(DatabaseModel);

Restriccion.model = 'restricciones';
Restriccion.modelFront = 'restricciones';

// GET /movilidad/restricciones/inspectores[?incluirInactivos=true]
// → { inspectores:[{empleadoId,nombre,siglas,estado,activo,faltan,base}],
//     configurados, aMedias, sinConfigurar, total,
//     completas, sinBase, sinRadio, sinZona, puedeRecalcularBases }
// incluirInactivos: entran también los empleados de baja (para el toggle "Inspector activo").
// faltan (#376): subconjunto de ['BASE','RADIO','ZONA'] que le falta a la ficha, en ese orden;
// [] = los tiene los tres. Es información AL LADO de `estado`, que no cambia de significado: RADIO
// no entra en el estado. Los contadores por campo de la respuesta van sobre los inspectores que
// devuelve esta llamada; la pantalla recalcula los suyos para que cuadren con el toggle.
// base (#774): {lat,lon,origen,motivoSinBase,textoPartida,referencia,cpsPromediados,fechaCalculo,
// desactualizada}, o null si nunca se ha calculado. origen ∈ FICHA_RESTRICCIONES · CP_EXACTO ·
// CP_3_DIGITOS · POBLACION · OFICINA_APROXIMADA · SIN_BASE. puedeRecalcularBases: si quien mira
// puede llamar a recalcularBases (si no, ese botón no se dibuja).
Restriccion.listarInspectores = function(incluirInactivos) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/inspectores'
            + (incluirInactivos ? '?incluirInactivos=true' : ''),
        method: 'GET'
    }, false).then(unwrapDto);
};

// GET /movilidad/restricciones/{empleadoId} → ficha, o null si SIN_CONFIGURAR
Restriccion.getFicha = function(empleadoId) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(empleadoId),
        method: 'GET'
    }, false).then(unwrapDto);
};

// PUT /movilidad/restricciones/{empleadoId} → ficha guardada (upsert de la ficha completa)
Restriccion.guardar = function(empleadoId, data) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(empleadoId),
        method: 'PUT',
        data: data
    }, false).then(unwrapDto);
};

// POST /movilidad/restricciones/bases/recalcular → { total, porOrigen:{ORIGEN:n}, fallidos }
// Recalcula y guarda la base resuelta de todos los inspectores en vigor (#774).
Restriccion.recalcularBases = function() {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/bases/recalcular',
        method: 'POST'
    }, false).then(unwrapDto);
};

export default Restriccion;
